import {useEffect, useMemo} from 'react'

import {TokenInfo} from 'constData'
import {assetsConfig, fiatConfig, assetDefaultInfo} from 'config/wallet/assetsConfig'
import {testers} from 'config/wallet/testerEmails'

import useProfile from './useProfile'

const useWalletConfig = (assetId, {onNotFound} = {}) => {
  const {profile} = useProfile()

  const walletInfo = useMemo(() => {
    const assetIdLower = assetId?.toLowerCase()

    if (assetIdLower === 'fiat' || assetIdLower === 'usd') return fiatConfig

    const info = assetsConfig.find(({id}) => id.toLowerCase() === assetIdLower)
    if (info == null) {
      onNotFound && onNotFound()
    }

    if (assetIdLower === TokenInfo.XON.urlId && profile && testers.includes(profile.email)) {
      return {
        ...info,
        canBuy: true,
      }
    }

    return info
  }, [assetId, onNotFound, profile])

  const config = useMemo(
    () => ({
      ...assetDefaultInfo,
      ...walletInfo,
    }),
    [walletInfo],
  )

  useEffect(() => {
    if (config && !config.enabled && onNotFound) {
      onNotFound()
    }
  }, [config, onNotFound])

  return config
}

export default useWalletConfig
